export default __webpack_public_path__ + "static/media/Microbusiness1.646532ca.png";